import React from "react"
// Styles
import {BtnDanger, BtnPending, BtnCancelled, BtnSuccess} from "./index.style"

const StatusButton = ({status}) => {
	switch (status) {
		case "pending":
			return <BtnPending title={status} width={"60%"} variant='tertiary' size='extra-small' />
		case "cancelled":
			return <BtnCancelled title={status} width={"60%"} variant='tertiary' size='extra-small' />
		case "approved":
			return <BtnSuccess title={status} width={"60%"} variant='tertiary' size='extra-small' />
		case "denied":
			return <BtnDanger title={status} width={"60%"} variant='tertiary' size='extra-small' />
		default:
			return <BtnDanger title={status} width={"60%"} variant='tertiary' size='extra-small' />
	}
}

export default StatusButton
